import { Enum } from '@/enums/system';
import { formatter, request } from '@/utils/request';

const getApprovalUrl = (formTypeId: number) => {
  let url = '';
  if (formTypeId == Enum.FormType.ACTIVITY_APPLICATION) {
    url = '/expenseapi/saButtons/approval';
  } else if (formTypeId == Enum.FormType.PRE_SA_APPLICATION) {
    url = '/expenseapi/psaButtons/approval';
  } else if (formTypeId == Enum.FormType.ACTIVITY_MKT_APPLICATION) {
    url = '/expenseapi/saMktButtons/approval';
  } else if (formTypeId == Enum.FormType.ACTIVITY_SETTLEMENT) {
    url = '/expenseapi/ssButtons/approval';
  } else if (
    formTypeId == Enum.FormType.ACTIVITY_PAYMENT ||
    formTypeId == Enum.FormType.PRE_PAYMENT ||
    formTypeId == Enum.FormType.CONTRACT_REBATE_PAYMENT ||
    formTypeId == Enum.FormType.POLICY_REBATE_PAYMENT
  ) {
    url = '/expenseapi/spButtons/approval';
  } else if (formTypeId == Enum.FormType.ACTIVITY_MKT_PAYMENT || formTypeId == Enum.FormType.ACTIVITY_MKT_PRE_PAYMENT) {
    url = '/expenseapi/spMktButtons/approval';
  } else if (formTypeId == Enum.FormType.PROJECT_APPLICATION) {
    url = '/expenseapi/buttons/approval';
  }
  return url;
};

const getReadUrl = (formTypeId: number) => {
  let url = '';
  if (formTypeId == Enum.FormType.ACTIVITY_APPLICATION) {
    url = '/expenseapi/saButtons/read';
  } else if (formTypeId == Enum.FormType.ACTIVITY_MKT_APPLICATION) {
    url = '/expenseapi/saMktButtons/read';
  } else if (formTypeId == Enum.FormType.ACTIVITY_SETTLEMENT) {
    url = '/expenseapi/ssButtons/read';
  } else if (
    formTypeId == Enum.FormType.ACTIVITY_PAYMENT ||
    formTypeId == Enum.FormType.CONTRACT_REBATE_PAYMENT ||
    formTypeId == Enum.FormType.POLICY_REBATE_PAYMENT
  ) {
    url = '/expenseapi/spButtons/read';
  } else if (formTypeId == Enum.FormType.ACTIVITY_MKT_PAYMENT || formTypeId == Enum.FormType.ACTIVITY_MKT_PRE_PAYMENT) {
    url = '/expenseapi/spMktButtons/read';
  } else if (formTypeId == Enum.FormType.PROJECT_APPLICATION) {
    url = '/expenseapi/buttons/read';
  }
  return url;
};

export namespace FormApi {
  export const Path = {
    Get: '/expenseapi/form/get',
    GetByFormNo: '/expenseapi/form/getByFormNo',
    GetFormWarningCount: '/expenseapi/form/getFormWarningCount',
    QueryForMyDraft: '/reportapi/form/queryForMyDraft',
    SearchWaitForMyApprovalCount: '/reportapi/form/searchWaitForMyApprovalCount',
    QueryForWaitForMyApproval: '/reportapi/form/queryForWaitForMyApproval',
    QueryForMyCommunicated: '/reportapi/form/queryForMyCommunicated',
    QueryForMySystemMsg: '/reportapi/form/queryForMySystemMsg',
    SearchWaitForMyApprovalOtherCount: '/reportapi/form/searchWaitForMyApprovalOtherCount',
    SearchMailToMyApprovedCount: '/reportapi/form/searchMailToMyApprovedCount',
    SearchMyCommunicatedCount: '/reportapi/form/searchMyCommunicatedCount',
    SearchMySystemMsgCount: '/reportapi/form/searchMySystemMsgCount',
    QueryForMailToMyApproved: '/reportapi/form/queryForMailToMyApproved',
    QueryForWaitForMyApprovalOther: '/reportapi/form/queryForWaitForMyApprovalOther',
    QueryForMyApproved: '/reportapi/form/queryForMyApproved',
    QueryForMySubmit: '/reportapi/form/queryForMySubmit',
    DoesAccess: '/expenseapi/form/doesAccess',
    AllowInterveneFlow: '/expenseapi/form/allowInterveneFlow',
    ExportForMailToMyApproved: '/reportapi/form/exportForMailToMyApproved',
  }

  export async function getFormWarningCount(formId: Number) {
    const options = {
      method: 'GET',
      body: {
        formId: formId
      },
    };
    return request<API.ResponseResult<number>>(Path.GetFormWarningCount, formatter(options));
  }

  export async function get(id: Number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.Form>>(Path.Get, formatter(options));
  }
  export async function getByFormNo(id: string) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.Form>>(Path.GetByFormNo, formatter(options));
  }

  export async function doesAccess(formId?: Number) {
    const options = {
      method: 'GET',
      body: {
        formId: formId,
      },
    };
    return request<API.ResponseResult<boolean>>(Path.DoesAccess, formatter(options));
  }

  export async function allowInterveneFlow(formId?: Number) {
    const options = {
      method: 'GET',
      body: {
        formId: formId,
      },
    };
    return request<API.ResponseResult<boolean>>(Path.AllowInterveneFlow, formatter(options));
  }


  export async function postApproval(body: API.ButtonArgs, formTypeId: number) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(getApprovalUrl(formTypeId), formatter(options));
  }

  export async function queryForMyDraft(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormQuery>>(Path.QueryForMyDraft, formatter(options));
  }
  export async function getWaitForMyApprovalCount() {
    const options = {
      method: 'POST',
      body: {

      },
    };
    return request<API.ResponseResult<number>>(Path.SearchWaitForMyApprovalCount, formatter(options));
  }
  export async function queryForWaitForMyApproval(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormQuery>>(Path.QueryForWaitForMyApproval, formatter(options));
  }


  export async function queryForMyCommunicated(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormQuery>>(Path.QueryForMyCommunicated, formatter(options));
  }

  export async function queryForMySystemMsg(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormQuery>>(Path.QueryForMySystemMsg, formatter(options));
  }

  export async function getMySystemMsgCount() {
    const options = {
      method: 'POST',
      body: {},
    };
    return request<API.ResponseResult<number>>(Path.SearchMySystemMsgCount, formatter(options));
  }

  export async function getMyCommunicatedCount() {
    const options = {
      method: 'POST',
      body: {},
    };
    return request<API.ResponseResult<number>>(Path.SearchMyCommunicatedCount, formatter(options));
  }

  export async function getMailToMyApprovedCount() {
    const options = {
      method: 'POST',
      body: {},
    };
    return request<API.ResponseResult<number>>(Path.SearchMailToMyApprovedCount, formatter(options));
  }

  export async function queryForMailToMyApproved(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormQuery>>(Path.QueryForMailToMyApproved, formatter(options));
  }

  export async function queryForWaitForMyApprovalOther(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormQuery>>(Path.QueryForWaitForMyApprovalOther, formatter(options));
  }
  export async function queryForMyApproved(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormQuery>>(Path.QueryForMyApproved, formatter(options));
  }
  export async function queryForMySubmit(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormQuery>>(Path.QueryForMySubmit, formatter(options));
  }

  export async function exportForMailToMyApproved(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.FormQuery>>(Path.ExportForMailToMyApproved, formatter(options));
  }

  export async function postRead(body: API.ButtonArgs, formTypeId: number) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(getReadUrl(formTypeId), formatter(options));
  }

}
